<template>
  <v-row dense>
    <v-col cols="12">
      <span class="caption font-weight-bold">Tipo de compra</span>
      <div>
        {{ formData.TIPO_COMPRA | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
};
</script>
